<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
</style>
<template>
  <div>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        เพิ่มข้อมูลรถเก็บขน
      </div>
      <v-spacer></v-spacer>

      <v-btn
        outlined
        color="indigo"
        style="margin-right: 10px"
        elevation="0"
        dark
        link
        :to="'/manage/all-car'"
        >ย้อนกลับ
      </v-btn>

      <v-btn
        color="success"
        elevation="0"
        dark
        v-if="isEdit == false"
        @click="save"
      >
        <v-icon left>mdi-file-plus</v-icon>บันทึก
      </v-btn>

      <v-btn color="info" elevation="0" dark v-else @click="saveupdate">
        <v-icon left>mdi-file-plus</v-icon>แก้ไข
      </v-btn>
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-row>
        <v-col cols="12" lg="6">
          เลขทะเบียน :
          <v-text-field
            prepend-icon="mdi-card-bulleted"
            dense
            outlined
            v-model="carNumber"
            :rules="setCar_Rules"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="6">
          ประเภทรถ :
          <v-select
            prepend-icon="mdi-car-wash"
            color="black"
            :items="cartype"
            v-model="setCartype"
            item-text="cartype"
            :rules="setCar_Rules"
            outlined
            dense
            return-object
          ></v-select>
        </v-col>
        <v-col cols="12" lg="6" class="mt-n10">
          ยี่ห้อ :
          <v-text-field
            prepend-icon="mdi-car-shift-pattern"
            dense
            outlined
            v-model="brand"
            :rules="setCar_Rules"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="6" class="mt-n10">
          รุ่น :
          <v-text-field
            prepend-icon="mdi-car-shift-pattern"
            dense
            outlined
            v-model="generation"
            :rules="setCar_Rules"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="6" class="mt-n10">
          รหัสรถ :
          <v-text-field
            prepend-icon="mdi-car-shift-pattern"
            dense
            outlined
            v-model="car_code"
            :rules="setCar_Rules"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
      <v-divider></v-divider>
    </v-form>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: `carrier-form`,
  data() {
    return {
      cartype: ["รถเล็ก", "รถใหญ่"],
      setCar_Rules: [(v) => !!v || ""],
      valid: false,
      lazy: false,
      isEdit: this.$store.getters["Carrier/GET_isEdit"],
    };
  },
  methods: {
    save() {
      let Insert_Car = {
        CAR_NUMBER: this.carNumber,
        CAR_TYPE: this.setCartype,
        CAR_BRAND: this.brand,
        CAR_GENERATION: this.generation,
        CAR_CODE: this.car_code,
      };
      if (this.$refs.form.validate()) { 
        this.$token_api
          .post("/insert-car", Insert_Car)
          .then((response) => { 
            this.$store.dispatch("Carrier/car_reset");
            this.$swal("บันทึกสำเร็จ", "สำเร็จ", "success");
            window.location.href = `${this.$global_link}/manage/all-car`;
          })
          .catch((err) => {});
      } else {
        this.$swal(
          "กรุณากรอกข้อมูลให้ถูกต้องครบถ้วน",
          "เกิดข้อผิดพลาด",
          "error"
        );
      }
    },
    saveupdate() {
      let update_Car = {
        CAR_NUMBER: this.carNumber,
        CAR_TYPE: this.setCartype,
        CAR_BRAND: this.brand,
        CAR_GENERATION: this.generation,
        CAR_CODE: this.car_code,
        AUTO_ID: this.$store.getters["Carrier/GET_CAR_AUTO_ID"],
      }; 
      if (this.$refs.form.validate()) {
        this.$token_api
          .post("/update-car", update_Car)
          .then((response) => {
            //console.log(response.data);
            this.$refs.form.reset();
            this.$store.dispatch("Carrier/car_reset");
            this.$swal("แกไข้สำเร็จ", "สำเร็จ", "success");
            window.location.href = `${this.$global_link}/manage/all-car`;
          })
          .catch((err) => {});
      } else {
        this.$swal(
          "กรุณากรอกข้อมูลให้ถูกต้องครบถ้วน",
          "เกิดข้อผิดพลาด",
          "error"
        );
      }
    },
    close() {
      this.clear_form();
    },
    clear_form() {
      this.$emit("closeDi");
      this.$refs.form.reset();
      this.$store.dispatch("Carrier/car_reset");
      this.$emit("refreshData");
      //this.$store.commit("Carrier/SET_isEdit", false);
    },
  },
  computed: {
    carNumber: {
      get() {
        return this.$store.getters["Carrier/GET_CAR_NUMBER"];
      },
      set(value) {
        if (value) {
          this.$store.commit("Carrier/SET_CAR_NUMBER", value);
        }
      },
    },
    setCartype: {
      get() {
        return this.$store.getters["Carrier/GET_CAR_TYPE"];
      },
      set(value) {
        if (value) {
          this.$store.commit("Carrier/SET_CAR_TYPE", value);
        }
      },
    },
    brand: {
      get() {
        return this.$store.getters["Carrier/GET_CAR_BRAND"];
      },
      set(value) {
        if (value) {
          this.$store.commit("Carrier/SET_CAR_BRAND", value);
        }
      },
    },
    generation: {
      get() {
        return this.$store.getters["Carrier/GET_CAR_GENERATION"];
      },
      set(value) {
        if (value) {
          this.$store.commit("Carrier/SET_CAR_GENERATION", value);
        }
      },
    },
    car_code: {
      get() {
        return this.$store.getters["Carrier/GET_CAR_CODE"];
      },
      set(value) {
        if (value) {
          this.$store.commit("Carrier/SET_CAR_CODE", value);
        }
      },
    },
  },
};
</script>